import fetch from '../api/fetch'

/**
 * 	Action to fetch agency summary data
 *
 *  @param     {string} URL [/api/v1/dashboard/summary]
 * 	@method GET
 */

export function fetchAgencySummary(userId: number) {
    return {
        type: 'FETCH_AGENCY_SUMMARY',
        payload: fetch(`/dashboard/summary${(userId) ? '?userId=' + userId : ''}`, { method: 'GET' }),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/agencySummary.ts